require("./src/assets/styles/sanitize.css");
require("./src/assets/styles/fonts.css");
import "animate.css/animate.min.css";
